/* _customled-mobile-nav-flatten.js — Custom LED owned  [M1.21]
 *
 * The "by make" mega-menu columns (e.g. OEM Connectors → "Connectors by Make" →
 * Ducati/Honda/…) need an L2 wrapper so the DESKTOP mega-menu renders a proper
 * column header + L3 list (consistent with every other tab). But the MOBILE
 * drawer renders that wrapper as an extra expand step — tap OEM Connectors, then
 * tap "Connectors by Make", then see the makes — a pointless level on mobile.
 *
 * This unwraps such a wrapper IN THE MOBILE DRAWER ONLY: the make <li>s are
 * promoted to sit directly under the parent category, and the now-empty wrapper
 * row is removed. Result on mobile: OEM Connectors → makes (one expand). The
 * desktop mega-menu is a separate DOM (.mega-menu-*) and is untouched; running
 * on desktop only operates on the hidden mobile-drawer markup (harmless).
 *
 * A wrapper is identified structurally — a mobile item whose own sub-list is a
 * set of make-filtered collection links — so it generalizes to any future
 * "by make" branch and needs no per-title hardcoding. Idempotent; owned; zero
 * vendor edits. Loaded globally (header ships on every page).
 */
(function () {
  "use strict";
  function unwrap() {
    var items = [].slice.call(document.querySelectorAll("li.navigation-mobile-item"));
    items.forEach(function (li) {
      if (li.getAttribute("data-cl-unwrapped")) return;
      // the wrapper's DIRECT child <ul> (its sub-list)
      var subUl = null;
      for (var i = 0; i < li.children.length; i++) {
        if (li.children[i].tagName === "UL") { subUl = li.children[i]; break; }
      }
      if (!subUl) return;
      var makeLinks = subUl.querySelectorAll(
        ':scope > li.navigation-mobile-item > .navigation-mobile-item-link > a[href*="filter.p.m.custom.vehicle_make"]'
      );
      // require a real make list (>=2) so we only flatten "by make" wrappers
      if (makeLinks.length < 2) return;
      li.setAttribute("data-cl-unwrapped", "1");
      var parentUl = li.parentNode;
      if (!parentUl) return;
      // promote each make <li> to the wrapper's position, then drop the wrapper
      [].slice.call(subUl.children).forEach(function (makeLi) {
        parentUl.insertBefore(makeLi, li);
      });
      parentUl.removeChild(li);
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", unwrap);
  else unwrap();
})();
